import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Client, User, UsersQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const USER_URL = `${API_URL}/get-clients`
const GET_USERS_URL = `${API_URL}/get-clients`
const REGISTER_USER_URL = `${API_URL}/register`
const DEL_CLIENT_URL = `${API_URL}/del-clients`
const UPDATE_CLIENT_URL = `${API_URL}/update-client`
const PROJECT_URL = `${API_URL}/get-projects`

const getUsers = (query: string): Promise<UsersQueryResponse> => {
  return axios
    .post(`${GET_USERS_URL}?${query}`)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}
const getClient = (id: string): Promise<UsersQueryResponse> => {
  return axios
    .post(`${GET_USERS_URL}?`, {
      id:id
    })
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}
const   getClientById = (id: ID): Promise<User | undefined> => {
  return axios
    .post(`${USER_URL}/${id}`)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}
const getProjectById = (id: string): Promise<UsersQueryResponse> => {
  return axios
    .post(`${PROJECT_URL}`,{
      id:id
    })
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}
const createUser = (user: User): Promise<User | undefined> => {
  return axios
    .post(REGISTER_USER_URL, user)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}

const deleteUser = (userId: ID): Promise<void> => {
  return axios.post(`${DEL_CLIENT_URL}`,{
    id:userId
  }).then(() => {})
}

const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.post(`${DEL_CLIENT_URL}`, {
    id:id
  }))
  return axios.all(requests).then(() => {})
}
const updateUser = (user: User): Promise<User | undefined> => {
  return axios
    .post(`${UPDATE_CLIENT_URL}`, {
      type:4,
      name:"muhaddis",
      email:"muhaddisrehman12@gmail.com",
      password:"12345678",
      password_confirmation:"12345678",
      phone:"03244336382",
      street:"2",
      city:"lahore",
      state:"pj",
      zip_code:"50000",
      country:"pk",
      address:"ABZ",
      
  })
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}
const updateClient = (user: Client): Promise<Client | undefined> => {
  return axios
    .post(`${REGISTER_USER_URL}`, {
      type:4,
      name:"muhaddis",
      email:"muhaddisrehman12@gmail.com",
      password:"12345678",
      password_confirmation:"12345678",
      phone:"03244336382",
      street:"2",
      city:"lahore",
      state:"pj",
      zip_code:"50000",
      country:"pk",
      address:"ABZ",
      
  })
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}
export {getUsers, deleteUser, deleteSelectedUsers, getClientById, createUser, updateUser, getClient, getProjectById}
